(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["atelier-hero"] && !Shopify.designMode) return;
  try {
    (()=>{if(matchMedia('(prefers-reduced-motion: reduce)').matches)return;const init=()=>{const nodes=document.querySelectorAll('.aa>*,.ac>*,.ap>*,.aj>*,.ads>header,.ads-chapter,.ak>*,.acl>*,.cp>*');const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('atelier-motion-visible');observer.unobserve(entry.target)}}),{threshold:.1,rootMargin:'0px 0px -7%'});nodes.forEach(node=>{if(node.dataset.atelierMotion)return;node.dataset.atelierMotion='true';node.classList.add('atelier-motion-item');observer.observe(node)})};init();document.addEventListener('shopify:section:load',init)})();
(()=>{if(matchMedia('(prefers-reduced-motion: reduce)').matches)return;
const TILT='.ap-grid article,.aj-card,.ak-grid article,.ac-grid a,.cp-option';
const on=(e)=>{const c=e.currentTarget;const r=c.getBoundingClientRect();
if(!r.width||!r.height)return;
const k=(v)=>Math.max(-.5,Math.min(.5,v));
const dx=k((e.clientX-r.left)/r.width-.5),dy=k((e.clientY-r.top)/r.height-.5);
c.style.transform=`perspective(820px) rotateY(${dx*5}deg) rotateX(${-dy*5}deg)`;};
const off=(e)=>{e.currentTarget.style.transform='';};
const bind=()=>document.querySelectorAll(TILT).forEach(c=>{if(c.dataset.tiltReady)return;
c.dataset.tiltReady='1';c.addEventListener('pointerenter',on);c.addEventListener('pointermove',on);
c.addEventListener('pointerleave',off);});
bind();document.addEventListener('shopify:section:load',bind);})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["community-pick"] && !Shopify.designMode) return;
  try {
    (()=>{const reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;const set=(bar,animate)=>{if(!bar)return;const v=(bar.dataset.cpShare||'0')+'%';if(!animate||reduce){bar.style.width=v;return}bar.style.width='0%';void bar.offsetWidth;requestAnimationFrame(()=>{bar.style.width=v})};const init=()=>{const bars=[...document.querySelectorAll('.cp-meter i')];if(!bars.length)return;document.querySelectorAll('.cp-option').forEach(card=>{if(card.dataset.cpReady)return;card.dataset.cpReady='1';const bar=card.querySelector('.cp-meter i');card.addEventListener('pointerenter',()=>set(bar,true));const btn=card.querySelector('[data-cp-vote]');if(btn)btn.addEventListener('click',()=>{card.classList.add('is-voted');btn.textContent=btn.dataset.cpVoted||btn.textContent;set(bar,true)})});if(reduce){bars.forEach(b=>set(b,false));return}const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(!entry.isIntersecting)return;set(entry.target,true);observer.unobserve(entry.target)}),{threshold:.35});bars.forEach(b=>{if(b.dataset.cpSeen)return;b.dataset.cpSeen='1';observer.observe(b)})};init();document.addEventListener('shopify:section:load',init)})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["harbor-home"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initAtelier = (root) => {
    if (!root || root.dataset.motionReady === 'true') return;
    root.dataset.motionReady = 'true';
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const targets = root.querySelectorAll('.atelier-intro > *, .atelier-duo__card, .atelier-market header, .atelier-products article, .atelier-origin > *, .atelier-chronicle > header, .atelier-chronicle__image, .atelier-chronicle__chapters article, .atelier-serve > *, .atelier-closing > *');
    targets.forEach((item) => {
      item.classList.add('atelier-reveal');
      if (item.matches('.atelier-duo__card, .atelier-chronicle__image, .atelier-closing__image')) item.classList.add('atelier-reveal--image');
    });
    root.classList.add('is-motion-ready');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    targets.forEach((item) => observer.observe(item));
  };
  document.querySelectorAll('.atelier').forEach(initAtelier);
  document.addEventListener('shopify:section:load', (event) => initAtelier(event.target.querySelector('.atelier')));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
